import { Url } from '@wix/da-url';
import { VideoAspectRatio, VideoModel } from '../../types/store';

export interface ModelProperties {
  type: VideoModel;
  name: string;
  id: string;
  logo: string;
  priceRange: number;
  isCore: boolean;
  hasSound: boolean;
  isMature: boolean;
  backgroundUrl: string;
  availableAspectRatios: VideoAspectRatio[];
  availableDurations: number[];
}

export const models: ModelProperties[] = [
  {
    type: VideoModel.HAILUO,
    name: 'Hailuo 2',
    id: 'HAILUO_2_3',
    priceRange: 2,
    isCore: false,
    hasSound: false,
    isMature: true,
    logo: Url.staticCDNLink('video_generator/hailuo.png'),
    backgroundUrl: Url.staticCDNLink('video_generator/hailuo_bg.gif'),
    availableAspectRatios: ['4:3', '16:9'],
    availableDurations: [6, 10],
  },
  {
    type: VideoModel.VEO,
    name: 'VEO 3',
    id: 'GOOGLE_VEO_3_1_FAST',
    priceRange: 3,
    isCore: true,
    hasSound: true,
    isMature: false,
    logo: Url.staticCDNLink('video_generator/veo.png'),
    backgroundUrl: Url.staticCDNLink('video_generator/veo_bg.gif'),
    availableAspectRatios: ['16:9', '9:16'],
    availableDurations: [4, 6, 8],
  },
  {
    type: VideoModel.WAN,
    name: 'Wan',
    id: 'WAN_2_2_A14B',
    priceRange: 1,
    isCore: true,
    hasSound: false,
    isMature: true,
    logo: Url.staticCDNLink('video_generator/wan.png'),
    backgroundUrl: Url.staticCDNLink('video_generator/wan_bg.gif'),
    availableAspectRatios: ['16:9', '4:3', '1:1', '3:4', '9:16'],
    availableDurations: [5, 8],
  },
  {
    type: VideoModel.SEEDANCE,
    name: 'Seedance',
    id: 'SEEDANCE_1_0_PRO_FAST',
    priceRange: 1,
    isCore: true,
    hasSound: false,
    isMature: false,
    logo: Url.staticCDNLink('video_generator/seedance.png'),
    backgroundUrl: Url.staticCDNLink('video_generator/seedance_bg.gif'),
    availableAspectRatios: ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'],
    availableDurations: [4, 8, 12],
  },
];

export const getModelPropertiesByType = (
  type: VideoModel
): ModelProperties | undefined => {
  return models.find(model => model.type === type);
};

export const getModelPropertiesById = (
  id: string
): ModelProperties | undefined => {
  return models.find(model => model.id === id);
};
